export default "__VITE_ASSET__DY43aE5k__"